import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { MbtiCreateAlertComponent } from "src/app/common/modals/mbti-create-alert/mbti-create-alert.component";
import { AskComment } from 'src/app/interfaces/ask';
import { LogEvent } from "src/app/interfaces/log";
import { AskDetailWithInteraction } from "src/app/pages/ask/ask.component";
import { AskService } from 'src/app/services/ask/ask.service';
import { AskPostDetailCommentLikeClickedParams, AskPostDetailPostLikeClickedParams, AskScreenName } from "src/app/services/log/ask/ask-log";
import { LogService } from 'src/app/services/log/log.service';
import { MBTI } from './../../../../interfaces/mbti';
import { ModalService } from './../../../../services/modal/modal.service';
import { RouterService } from './../../../../services/router/router.service';

@Component({
  selector: 'app-ask-detail',
  templateUrl: './ask-detail.component.html',
  styleUrls: ['./ask-detail.component.scss']
})
export class AskDetailComponent implements OnChanges {
  constructor(
    private routerService: RouterService,
    private askService: AskService,
    private logService: LogService,
    private modalService: ModalService) {
  }

  @Input() data: AskDetailWithInteraction | undefined;
  @Input() entryPointPostId: number | undefined;
  @Input() myMbti: MBTI | null | undefined;
  @Input() listMbti: MBTI | undefined;
  @Input() location: AskScreenName = 'ask_post_detail'; 
  @Output() onClickComment = new EventEmitter<AskDetailWithInteraction>()
  private isInitialLoggingLogged = false;

  ngOnChanges(): void {
    if (!this.isInitialLoggingLogged && this.data !== undefined) {
      this.isInitialLoggingLogged = true;
      if (this.location === 'mbti_host_quiz_report') {
        this.logService.eventLogging(LogEvent.ASK_PREVIEW_IMPRESSION, {
          screenName: 'mbti_host_quiz_report',
          authorMbti: this.data.writerMbtiType,
          postLength: this.data.content.length,
          likeCount: this.data.likeCount,
          commentCount: this.data.comments.length
        })
      }
    }
  }

  onClickPostLike(item: AskDetailWithInteraction, value: boolean): void {
    this.askPostDetailPostLikeClickedLogging(item, value);
  }

  onClickCommentLike(post: AskDetailWithInteraction, comment: AskComment, value: boolean): void {
    this.askPostDetailCommentLikeClickedLogging(post, comment, value);
  }

  async onClickCommentInput(): Promise<void> {
    if (!this.myMbti) {
      const alertModal = await this.modalService.openBottomSheet(MbtiCreateAlertComponent)
      await alertModal.present();
      return;
    }
    if (this.location === 'mbti_host_quiz_report') {
      this.moveToAskListPage('comment_icon');
    } else {
      this.onClickComment.emit(this.data);
    }
  }

  onClickShowAllComments(): void {
    if (this.location !== 'mbti_host_quiz_report' && this.data !== undefined) {
      this.data.showAllComments = true;
      this.logService.eventLogging(LogEvent.ASK_ALL_COMMENT_CLICKED, {
        screenName: 'ask_post_detail',
        postId: this.data.id,
        isEntryPost: this.entryPointPostId === this.data.id,
        likeCount: this.data.likeCount,
        commentCount: this.data.comments.length,
        userMbti: this.myMbti,
        listMbti: this.listMbti,
        isListMbtiMine: this.listMbti === this.myMbti,
        targetMbti: this.data.mentionMbtiType,
        isTargetMbtiMine: this.data.mentionMbtiType === this.myMbti,
        authorMbti: this.data.writerMbtiType,
        postLength: this.data.content.length 
      });
    }
    if (this.location === 'mbti_host_quiz_report') {
      this.moveToAskListPage('show_all_comments');
    }
  }

  private askPostDetailPostLikeClickedLogging(post: AskDetailWithInteraction, value: boolean): void {
    if (!this.myMbti) {
      return;
    }

    const params: AskPostDetailPostLikeClickedParams = {
      screenName: this.location,
      postId: post.id,
      isEntryPost: this.entryPointPostId === post.id,
      likeCount: post.likeCount,
      commentCount: post.comments.length,
      userMbti: this.myMbti,
      listMbti: this.listMbti,
      isListMbtiMine: this.listMbti === this.myMbti,
      targetMbti: post.mentionMbtiType === 'ALL' ? undefined : post.mentionMbtiType,
      isTargetMbtiMine: post.mentionMbtiType === this.myMbti,
      authorMbti: post.writerMbtiType,
    }
    if (value) {
      this.logService.ask.askPostDetailPostLikeSetClicked(params);
    } else {
      this.logService.ask.askPostDetailPostLikeUnsetClicked(params);
    }
  }

  private askPostDetailCommentLikeClickedLogging(post: AskDetailWithInteraction, comment: AskComment, value: boolean): void {
    if (!this.myMbti) {
      return;
    }

    const params: AskPostDetailCommentLikeClickedParams = {
      screenName: this.location,
      postId: post.id,
      commentId: comment.id,
      isEntryPost: this.entryPointPostId === post.id,
      likeCount: comment.likeCount,
      userMbti: this.myMbti,
      authorMbti: comment.writerMbtiType
    }
    if (value) {
      this.logService.ask.askPostDetailCommentLikeSetClicked(params);
    } else {
      this.logService.ask.askPostDetailCommentLikeUnsetClicked(params);
    }
  }

  /** move and show modal */
  private async moveToAskListPage(clickElem: string): Promise<void> {
    this.askService.topAskPostDetail = this.data;
    this.routerService.navigate('ask', {
      queryParams: {
        showInitialModal: true
      }
    });
    if (this.data !== undefined) {
      const { writerMbtiType, likeCount, comments, content } = this.data;
      this.logService.eventLogging(LogEvent.QUIZ_RESULT_MORE_POST_CLICKED, {
        screenName: this.location, // 화면 식별자 
        userMbti: this.myMbti,//  접속자의 MBTI
        authorMbti: writerMbtiType,// 질문자의 MBTI
        likeCount: likeCount,//  포스트의 댓글 수
        commentCount: comments.length,//  포스트의 댓글 수
        postLength: content.length,//  포스트의 글자 수
        morePostButton: clickElem
      });
    }
  }
}
